import type { FeatureFlagConfig } from '@mondaygpt/constants'

export interface GateInputs {
  initialized: boolean
  currentUserId: string | undefined | null
  /** The session's business for flag purposes (`flagBusinessId`: never the pending sentinel). */
  currentBusinessId: string | undefined | null
  loadedForDistinctId: string | undefined
  /** The loaded PostHog value for a user flag (posthog-js answers the fallback if it has none). */
  readFlag: () => boolean
  /** For a business flag: the business the server flags belong to, and this flag's value there. */
  businessFlag: { settledFor: string | null; value: boolean | undefined }
}

/** The decision behind `useFeatureGateState`, pure so it can be unit tested. */
export function resolveGateState(
  flag: FeatureFlagConfig,
  inputs: GateInputs
): { enabled: boolean; settled: boolean } {
  if (flag.scope === 'business') {
    if (!inputs.currentBusinessId) return { enabled: false, settled: true }
    const settled = inputs.businessFlag.settledFor === inputs.currentBusinessId
    return {
      enabled: settled ? (inputs.businessFlag.value ?? flag.fallback) : flag.fallback,
      settled,
    }
  }

  if (!inputs.initialized) return { enabled: flag.fallback, settled: true }
  const settled = !inputs.currentUserId || inputs.loadedForDistinctId === inputs.currentUserId
  return { enabled: inputs.readFlag(), settled }
}
